<template>
   <div>
    <div class="overlay" :class="{'hidden': !show_results}"></div>
    <div class='desktop-search'>
        <SearchBar id='desktop_search_bar' @productsListener='productResults' @showResultsListener='showResultsListener' @enterPressedListener='showAllResults' :clear_search_watcher='clear_search_watcher'/>
    </div>

    <div @click='toggleMobileSearch' class='mobile-search-icon'><span class="fa-regular fa-magnifying-glass"></span></div>

        <div class='mobile-search'>
            <div class='mobile-search-content'>
                <SearchBar id='mobile_search_bar' @productsListener='productResults' @showResultsListener='showResultsListener' @enterPressedListener='showAllResults' :clear_search_watcher='clear_search_watcher'/>
                <div @click='closeMobileSearch' class='close-mobile-search-container'><div class="fa-regular fa-xmark close-mobile-search"></div></div>
            </div>
        </div>

        <SearchResults :show_results='show_results' :products='products' :total_product_count='total_product_count' :search_string='search_string' @productClickListener='productClicked' @showAllResultsListener='showAllResults' />

    </div>
</template>

<script>
import SearchBar from '@/ecom/components/navigation/header/search/SearchBar.vue';
import SearchResults from '@/ecom/components/navigation/header/search/SearchResults.vue';

export default {
    components: {SearchBar, SearchResults},
    data(){
        return{
            products: [],
            show_results: false,
            clear_search_watcher: null,
            total_product_count: 0,
            search_string: ''
        }
    },
    methods:{
        productResults(products, cleared_results, total_product_count, search_string){
            let show_results = !cleared_results;
            this.products = products;
            this.show_results = show_results; 
            this.total_product_count = total_product_count;
            this.search_string = search_string
        },
        showResultsListener(show_results){
            this.show_results = show_results;
        },
        toggleMobileSearch(){
            const mobile_menu = document.querySelector('.mobile-search');
            mobile_menu.classList.toggle('is-open');
        },
        closeMobileSearch(){
            const mobile_menu = document.querySelector('.mobile-search');
            mobile_menu.classList.remove('is-open');
        },
        productClicked(product){
            this.$router.push(`/${product.category_url}${product.producturl}`);
            this.clear_search_watcher = +new Date();
            this.show_results = false;
            this.closeMobileSearch();
        },
        showAllResults(search_string){
            if(typeof search_string !== 'undefined'){
                this.search_string = search_string
            }

            this.$router.push(`/search?q=${encodeURIComponent(this.search_string)}`)
            this.show_results = false;
            this.closeMobileSearch();
            this.clear_search_watcher = +new Date();
        }
      
    }
}
</script>

<style lang="scss" scoped>

.mobile-search {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 2;
    background-color: #FFF;
	color: black;
	transform: translateY(-100%);
	transition: 0.3s;
    transition: transform 330ms ease-in-out;
    overflow-y: auto;
    overflow-x: hidden;
}

.mobile-search.is-open {
	transform: translateY(0);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

.desktop-search{
    display: block;

    @media(max-width: 768px){
        display:none;
    }
}

.mobile-search-icon{
    font-size: 1.0rem;
    display: none;

    @media(max-width: 768px){
        display:block;
    }
}

.mobile-search-content{
    display: flex;
    justify-content: space-between;
    padding: 25px;
}

.close-mobile-search-container{
    display: flex;
    justify-content: flex-end;
}
.close-mobile-search{
    font-size: 2.1rem;
}
.overlay {
  position: fixed;
  top: calc(var(--top-nav-bar-height) + var(--desktop-menu-container-height)); 
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
    visibility: visible;
    opacity: 1;
    transition: visibility 0s, opacity 0.3s linear;
}

.hidden {
    //   display: none;
    
    // opacity: 1;
	// animation-name: fadeInOpacity;
	// animation-iteration-count: 1;
	// animation-timing-function: ease-in;
	// animation-duration: 5s;
    
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.3s linear;
}

</style>